import Container from 'components/Container/Container';
import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import CreateAdvertiserContainer from 'features/direct/advertiser/containers/CreateAdvertiserContainer/CreateAdvertiserContainer';
import { History } from 'history';
import { Agency, useAgencyMinimalQuery } from 'interfaces/generated.types';
import React from 'react';

interface ICreateAdvertiserPage {
  history: History;
  match: {
    params: {
      agencyId: string;
    };
  };
}

const CreateAdvertiserPage = ({ history, match }: ICreateAdvertiserPage) => {
  const { loading, data, error } = useAgencyMinimalQuery({
    variables: { id: match.params.agencyId },
  });

  if (!loading && (error || !(data && data.agencyLegacy)))
    return <Redirecting history={history} />;

  return (
    <main>
      <Container>
        <h1 className="sr-only">Create Advertiser</h1>
        {loading ? (
          <Loader />
        ) : (
          <CreateAdvertiserContainer
            history={history}
            match={match}
            agency={data?.agencyLegacy as Agency}
          />
        )}
      </Container>
    </main>
  );
};

export default CreateAdvertiserPage;
